module.exports = __webpack_public_path__ + "static/media/wrinkles_glabellar.646fde98.svg";